module.exports = __webpack_public_path__ + "img/who-has-what.fa18dd3e.jpg";